import type { AbgleichFeld } from '../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';

export type Quelle = 'e2n' | 'datev';

export const ABGLEICH_SPALTEN: { feld: AbgleichFeld; labelKey: string }[] = [
  { feld: 'personalnr', labelKey: 'domain.datev.abgleich.spalten.personalnr' },
  { feld: 'vorname', labelKey: 'domain.datev.abgleich.spalten.vorname' },
  { feld: 'nachname', labelKey: 'domain.datev.abgleich.spalten.nachname' },
  { feld: 'standort', labelKey: 'domain.datev.abgleich.spalten.standort' },
];

export const ABGLEICH_ZEILE_CLASS = 'h-10';
